module.exports = __webpack_public_path__ + "h5/img/home6.0f8e4b94.png";